import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';

import { registerEvmNetworkProviderBuilder } from '../../registerEvmNetworkProviderBuilder';
import { createWalletProviderFromEIP1193Provider } from '../../utils/createWalletProviderFromEIP1193Provider';
import { listenForEIP6963ProviderAnnouncement } from './../utils/listenForEIP6963ProviderAnnouncement';

export const EIP6963_EXTENSION_KEY = 'eip6963';

/**
 * Adds the EIP-6963 extension to the Dynamic client.
 *
 * This extension enables integration with wallets that support EIP-6963,
 * automatically detecting and registering compatible wallets for use with the Dynamic SDK.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A function that can be used to remove EIP-6963 global event listeners that were added.
  * @not-instrumented
 */
export const addEIP6963Extension = (client = getDefaultClient()) => {
  if (hasExtension({ extensionKey: EIP6963_EXTENSION_KEY }, client)) {
    return () => {
      // noop
    };
  }

  registerExtension({ extensionKey: EIP6963_EXTENSION_KEY }, client);
  registerEvmNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  return listenForEIP6963ProviderAnnouncement((detail) => {
    const walletProvider = createWalletProviderFromEIP1193Provider(
      {
        displayName: detail.info.name,
        eip1193: detail.provider,
        icon: detail.info.icon,
      },
      client
    );

    walletProviderRegistry.register({
      priority: WalletProviderPriority.WALLET_SELF_ANNOUNCEMENT_STANDARD,
      walletProvider,
    });
  });
};
